export default "__VITE_ASSET__CHI5rwCJ__"